<template>
    
    <body >
        <div class="oculto-impresion" id="app">
        <v-app>
            <v-app-bar
            app
            color="white"
            height="100"
            >
            <v-avatar
                class="mr-3"
                color="grey lighten-5"
                size="70"
            >
                <v-img
                contain
                max-height="150%"
                src="https://i.ibb.co/hChChjP/Captura.png"
				
                ></v-img>
            </v-avatar>

            <v-toolbar-title class="font-weight-black headline">
                Allure
            </v-toolbar-title>
            </v-app-bar>
            <section id="hero">
                <v-row no-gutters>
                <v-img
                    :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
                    :src="require('../assets/cortepelo.jpg')"
					gradient="to right, rgba(0, 0, 0, .3), rgba(5, 11, 31, .2)"
                >
                    <v-theme-provider dark>
                    <v-container fill-height>
						<v-card
							v-if="Mostrar"
							class="mx-auto"
							max-width="544"
							height="200"
							color="green"
							@click="ConfirmarCita()"
						>
							<v-img
								class="white--text align-center"
								height="100%"
								width="200"
								src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
								gradient="to right, rgba(5,255, 4, .5), rgba(5, 11, 31, .8)"
								>
								<v-card-title>Confirmar Cita</v-card-title>
							</v-img>

						</v-card>
						<v-card
							v-if="Mostrar"
							class="mx-auto"
							max-width="544"
							height="200"
							color="red"
							@click="CancelarCita()"
						>
							<v-img
								class="white--text align-center"
								height="100%"
								width="200"
								
								gradient="to right, rgba(255,4, 4, .4), rgba(255, 11, 31, .4)"
								src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
								>
								<v-card-title>Cancelar Cita</v-card-title>
							</v-img>

						</v-card>
                        <v-row
						v-if="!Mostrar"
                        align="center"
                        class="white--text mx-auto"
                        justify="center"
                        >
                        <v-col
                            class="white--text text-center"
                            cols="12"
                            tag="h1"
                        >
                            <span
                            class="font-weight-light"
                            >
                            Estimad@ {{Cliente}}. <br/> Su cita ha sido
                            </span>

                            <br>

                            <span
                            :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                            class="font-weight-black"
                            >
                            {{Estado}} 
                            </span>
							<br>
							<v-btn @click="EnviarWhatsApp()" v-if="Estado == 'Cancelada'">
								Para reprogramar su cita, de click aquí
							</v-btn>
							 <span
                            class="font-weight-light text-caption"
                            >
                            No tienes, que hacer nada más. ¡Te esperamos!
                            </span>
                        </v-col>

                        </v-row>
                    </v-container>
                    </v-theme-provider>
                </v-img>
                </v-row>
            </section>
				  <v-simple-table>
						<template v-slot:default>
						<thead>
							<tr>
							<th class="text-left">
								Name
							</th>
							<th class="text-left">
								RefFecha
							</th>
							<th class="text-left">
								Prestador
							</th>
							<th class="text-left">
								Estado
							</th>
							</tr>
						</thead>
						<tbody>
							<tr
							v-for="item in events"
							:key="item.name"
							>
							<td>{{ item.name }}</td>
							<td>{{ item.start2 }}</td>
							<td>{{ item.category }}</td>
							<td>{{ item.Estado }}</td>
							</tr>
						</tbody>
						</template>
					</v-simple-table>
            <v-footer
            class="justify-center"
            color="#292929"
            height="100"
            >
            <div class="title font-weight-light grey--text text--lighten-1 text-center">
                © {{ (new Date()).getFullYear() }} — Made with 💜 by Noah Systems
            </div>
            </v-footer>
        </v-app>
        </div>

        </body>
        
</template>

<script scoped>
import axios from 'axios'
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
import { db } from '@/main'
import QrcodeVue from 'qrcode.vue'

Vue.use(VueExcelXlsx);
  export default {
    data: () => ({
    events: [],
    Logo3: '',
	Estado : "",
    cedulaReceptor: '',
    Mostrar: true,
    
    }),
    components: {
      QrcodeVue,
    },

    computed: {
    formTitle () {
            return this.editedIndex === -1 ? 'Nuevo usuario' : 'Actualizar usuario'
    }
    
    },
    

    watch: {
      dialog (val) {
        val || this.close()
      },
      
    },

    created () {
		this.getEvents2();
		
    },

    methods: {
		async ConfirmarCita () {
		this.Mostrar = false;
		this.Estado = "Confirmada";
		var FechaInicio = "";
			for(var i = 0; i < this.events.length; ++i)
				{	
					FechaInicio = this.events[i].start2.substring(0,10)
					if(this.$route.params.fecha == FechaInicio){
						db.collection('chineate').doc(this.events[i].id).update({
							Estado: "Confirmado por el cliente",
							color: 'green'
						})
						.catch(function (error) {
						alert("Error confirmando, agreacedemos por favor confirmar por WhatsApp o telefono de forma manual");
						})
					}
					
						
				}
					
		},
		EnviarWhatsApp(){
			var url = 'https://wa.link/nk2f3j';
			var win = window.open(url, '_blank');
			win.focus();
		},
		async CancelarCita () {
		this.Mostrar = false;
		this.Estado = "Cancelada";
		var FechaInicio = "";
			for(var i = 0; i < this.events.length; ++i)
				{	
					FechaInicio = this.events[i].start2.substring(0,10)
					if(this.$route.params.fecha == FechaInicio){
						db.collection('chineate').doc(this.events[i].id).update({
							Estado: "Cancelada por el cliente",
							color: '#A200FF'
						})
						.catch(function (error) {
						alert("Error confirmando, agreacedemos por favor confirmar por WhatsApp o telefono de forma manual");
						})
					}
					
						
				}
					
		},
		async getEvents2 () {
			let snapshot = await db.collection('chineate').where('Telelfono', '==', this.$route.params.id).get();
			const events = []
			let date1 = null;
			let date2 = null;
			snapshot.forEach(doc => {
				let appData = doc.data()
				appData.id = doc.id

				date1 = new Date(appData.start)
				date1 = date1.getTime();

				date2 = new Date(appData.end)
				date2 = date2.getTime();
				this.Cliente = appData.Cliente;
				this.events.push({
				id: appData.id,
				start: date1,
				start2:appData.start2,
				end2:appData.end2,
				end: date2,
				name: appData.name,
				color: appData.color,
				IdMultiple : appData.IdMultiple,
				Participantes: appData.Participantes,
				Telelfono: appData.Telelfono,
				Cliente: appData.Cliente,
				category: appData.category,
				Usuario: appData.Usuario,
				Fecha: appData.Fecha,
				timed: true,
				Estado: appData.Estado,
				detalle: appData.detalle,
				})
			})
			
			//this.update();
		},
        listarLocalidad(){
            let me =this;
            let LogoTest= '';
            let self = this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
                axios.get('api/Localidades/ListarFiltrada/'+me.$route.params.localidad,configuracion).then(function(response){
                    //console.log(response);
                    me.localidadencabezado=response.data;
                    me.Logo2 = me.localidadencabezado[0].imagen;
                    function toDataURL(url, callback) {
                    var xhr = new XMLHttpRequest();
                    xhr.onload = function() {
                        var reader = new FileReader();
                        reader.onloadend = function() {
                        callback(reader.result);
                        }
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                    }
                    var url2 = me.Logo2;
                    
                        toDataURL(url2, function(dataUrl) {
                        console.log('RESULT:', dataUrl)
                        me.Logo3 = dataUrl;
                        }) 
                    }).catch(function(error){
                        console.log(error);
                    });

        },
        
    
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },
    },
  mounted(){
      this.getEvents2();
  }
  }

</script>
<style scoped>
    @media print {
    .oculto-impresion,
    .oculto-impresion * {
        display: none !important;
    }
    } 
</style>
My CRUD